import { render, staticRenderFns } from "./CreateApiDlg.vue?vue&type=template&id=89ab3cb6&"
import script from "./CreateApiDlg.vue?vue&type=script&lang=js&"
export * from "./CreateApiDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports